import * as React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import isRetina from "is-retina"
import ProductCard from "@components/Products/ProductCard";
import Slider from "react-slick";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


class NextArrow extends React.Component {
    constructor(props) {
        super(props);
    }

    render() { 
      return (
        <FontAwesomeIcon
          icon={["fas", "chevron-right"]}
          className={this.props.className}
          style={{ ...this.props.style }}
          onClick={this.props.onClick}
        />
      );
    }
}

class PrevArrow extends React.Component {
    constructor(props) {
        super(props);
    }

    render() { 
      return (
        <FontAwesomeIcon
          icon={["fas", "chevron-left"]}
          className={this.props.className}
          style={{ ...this.props.style }}
          onClick={this.props.onClick}
        />
      );
    }
}

@inject("store")
@observer
export default class GridProducts extends React.Component {
    @observable productIndex = 0;
    itemWidth = 325; // px width of the items we try to fit. Make this number smaller to fit more.

    state = {
        slidesToShow: 6, // default number to show
        hidden: true // hide by default
    };

    // model props
    constructor(props) {
        super(props);

        this.focusProduct = this.focusProduct.bind(this);
        this.openProductDialog = this.openProductDialog.bind(this);
        this.getProductUrl = this.getProductUrl.bind(this);
        this.slider = {
            settings : {
                dots: false,
                centerMode: false,
                infinite: false,
                speed: 500,
                slidesToScroll: 1,
                nextArrow: <NextArrow />,
                prevArrow: <PrevArrow />,
                onInit: () => {
                    this.setState((oldState) => Object.assign({}, oldState, { hidden: false })); // can't use spread here since it breaks SSR
                }
            }
        }

        this.containerRef = React.createRef(null);
    }

    getProductUrl(product) {
        return this.props.navigation.getProductUrl(product);
    }

    openProductDialog(e, product, position) {
        e.stopPropagation();
        e.preventDefault();
        this.props.store.navigation.openProductDialog(product, { listIndex: position });
    }


    focusProduct(e, i, product) {
        e.preventDefault();
    }

    componentWillUnmount() {
        if(this.resizeObserver) this.resizeObserver.disconnect();
    }
    
    componentDidMount() {
        if(this.containerRef.current === null) return;
        this.resizeObserver = new ResizeObserver((entries) => {
            if(entries.length === 0) return;
            const entry = entries[0];
            const width = entry.contentRect.width;

            const items = this.getNumberOfItemsToShow(width);
            
            if (this.state.slidesToShow !== items) {
                this.setState((oldState) => ({ ...oldState, slidesToShow : items }));
            }
        });

        const currentWidth = +this.containerRef.current.offsetWidth;
        const currentItems = this.getNumberOfItemsToShow(currentWidth);
        this.setState((oldState) => ({ ...oldState, slidesToShow : currentItems }));

        this.resizeObserver.observe(this.containerRef.current);
    }

    getNumberOfItemsToShow(width) {
        return Math.max(
            1, // Return at least one item
            Math.floor(width / this.itemWidth)
        );
    }


    render() {
        // Handle single, or grouped products
        const navigation = this.props.store.navigation;

        if (this.props.model.value == null) {
            return null;
        }
        
        let selectedProducts = this.props.model.value.products ? this.props.model.value.products : this.props.model.value;
        
        let style = null;
        if (navigation.mainSkinColor) {
            style = {backgroundColor: navigation.mainSkinColor};
        }
        
        let finalProducts = [];
        const products = navigation.contentProducts;

        var productArray = selectedProducts.split(",");
        for (var pa = 0; pa < productArray.length; pa++) {

            var product = products.find(el => ((("" + el.ProductId) === productArray[pa]) || ("" + el.ProductId) === ("products/" + productArray[pa])));

            if (product) {
                finalProducts.push(product);
            }
        }

        let numbersOfCols = 3;

        const isOdd = finalProducts.length % 2 === 1;

        switch (finalProducts.length) {
            case 1:
                numbersOfCols = 12;
                break;
            case 2:
                numbersOfCols = 6;
                break;
            case 3:
                numbersOfCols = 4;
                break;
            default:
                numbersOfCols = 3;
        }
        const retina = isRetina();

        const css = (this.state.hidden)
            ? "row grid-products hidden"
            : "row grid-products";

        const imageWidth = 200; // Math.round((1920 / 12) * (numbersOfCols * (retina ? 2 : 1)));
        return (
            <div className={css} style={style} ref={this.containerRef}>
                <div className={"col-lg-12"}>
                    <Slider {...this.slider.settings} slidesToShow={this.state.slidesToShow}>
                        {finalProducts.map((product) => {
                            return (
                                <div className={"col-lg-12"} key={"product-card" + product.ProductId}>
                                    <div className="product-outer">
                                        <div className="product-card product-card-framed">
                                            <ProductCard
                                                product={product}
                                                orderStore={this.props.store.order}
                                                navigation={this.props.store.navigation}
                                                listIndex={0}
                                                imageWidth={imageWidth}
                                            />
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                        )}
                    </Slider>
                </div>
            </div>
        );
    }
}